// extracted by mini-css-extract-plugin
export default {"list":"FmHZQwr6uZ9BbgLmQkKM"};